export enum BillingType {
  PAYG = 0,
  Subscription
}